export default __webpack_public_path__ + "static/media/eldorado_card.3dcf37a3.svg";